import React from 'react'
import { Map, MarkerClusterer } from 'react-kakao-maps-sdk'
import { CouponMapProps } from 'src/pages/CouponMapPage/index'
import styled from 'styled-components'
import BrandMenuBottomSheet from 'src/pages/CouponMapPage/_components/BrandMenuBottomSheet/view'
import RenderIf from 'src/components/common/RenderIf'
import cluster_img from 'src/assets/images/map/cluster_img.png'
import CouponMapHeader from 'src/pages/CouponMapPage/_components/CouponMapHeader'
import { Marker } from 'src/pages/CouponMapPage/_components/Marker'
import MapBottomContents from 'src/pages/CouponMapPage/_components/MapBottomContents'

const CouponMapPageView = (props: CouponMapProps) => {
  const { kakaoMapOptions, storeMarkers } = props

  const clusterOptions = {
    averageCenter: true,
    minLevel: 7,
    styles: S.MapClusterStyle,
    //marker안에 overlay를 제외하기 위해 나누기 2
    minClusterSize: 4,
    texts: (size: number) => (size / 2 > 99 ? `+99` : `${size / 2}`),
  }

  return (
    <React.Fragment>
      <CouponMapHeader {...props} />
      <S.KakaoMap {...kakaoMapOptions}>
        <Marker.Current {...props} />
        <RenderIf when={storeMarkers?.length !== 0}>
          <MarkerClusterer {...clusterOptions}>
            <Marker.Store {...props} />
          </MarkerClusterer>
        </RenderIf>
      </S.KakaoMap>
      <BrandMenuBottomSheet {...props} />
      <MapBottomContents {...props} />
    </React.Fragment>
  )
}

export default CouponMapPageView

const S = {
  KakaoMap: styled(Map)`
    width: 100%;
    height: 100%;
    display: block;
    min-height: calc(var(--vh, 1vh) * 100);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  `,
  MapClusterStyle: [
    {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '44px',
      height: '44px',
      background: `url(${cluster_img}) no-repeat center center`,
      backgroundSize: '44px 44px',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: 700,
      fontFamily: 'RobotoBold, sans-serif',
      color: 'var(--white)',
    },
  ],
}
